import React from "react";
import { Link } from "@reach/router";

const NavbarCertification = ({ user, signOut }) => {
  return (
    <nav className="bg-dark hide-mobile side-menu">
      <div className="container-fluid px-0">
        <div className="px-3">
          <Link to="/" className="navbar-brand" href="#landing">
            <img src="/img/Latina_Logo2.png" className="mw-100 w-100" />
          </Link>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="text-white mt-4">
          <ul className="side-menu-list">
            <li className="nav-item text-item">
              <Link to="/mycertification" className="nav-link">
                Home
              </Link>
            </li>
            <li className="nav-item text-item">
              <Link to="/mycertification/videos" className="nav-link">
                Videos
              </Link>
            </li>
            <li className="nav-item text-item">
              <Link to="/mycertification/documentos" className="nav-link">
                Documentos
              </Link>
            </li>
            <li className="nav-item text-item">
              <Link to="/mycertification/descargables" className="nav-link">
                Descargables
              </Link>
            </li>
            <li className="nav-item text-item">
              <Link to="/mycertification/descuentos" className="nav-link">
                Descuentos
              </Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {String(user.name).substr(0, 20)}
                {String(user.name).length > 20 ? "..." : ""}
                <i className="ms-2 fa fa-user-circle"></i>
              </a>
              <ul
                className="dropdown-menu user-menu"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <Link to="./informacion" className="dropdown-item">
                    Mi Información
                  </Link>
                </li>
                <li>
                  <Link to="./pagos" className="dropdown-item">
                    Mis Compras
                  </Link>
                </li>
                <li>
                  <Link to="./metodos" className="dropdown-item">
                    Mis Métodos de Pago
                  </Link>
                </li>
                <li className="mt-3">
                  <button
                    className="dropdown-item text-danger"
                    onClick={signOut}
                  >
                    Salir <i className="ms-2 fa fa-sign-out-alt"></i>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavbarCertification;
